import styled, { css } from 'styled-components';

export const DefaultGroupWrapper = styled.div`
    ${({ theme }) => css`
        p,
        li {
            font-weight: 200;
            line-height: 1.65;
        }

        h2,
        h3,
        h4,
        h5,
        h6 {
            font-weight: 200;
            font-size: 1.5rem;

            @media ${theme.breakpoints.large.media} {
                font-size: 1.75rem;
            }
        }
    `}
`;
